import { useState, useEffect } from "react";
import { Link } from "@tanstack/react-router";
import { Menu, X } from "lucide-react";
import { Logo } from "./Logo";

const NAV = [
  { to: "/" as const, label: "Inicio" },
  { to: "/areas" as const, label: "Áreas de Práctica" },
  { to: "/trayectoria" as const, label: "Socios" },
  { to: "/contacto" as const, label: "Contacto" },
];

export function SiteHeader() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`sticky top-0 z-50 transition-all duration-300 ${
        scrolled
          ? "border-b border-gold-500/20 bg-stone-100/95 backdrop-blur-md"
          : "border-b border-transparent bg-stone-100/80 backdrop-blur-sm"
      }`}
    >
      <div className="container-elegant flex h-20 items-center justify-between md:h-24">
        <Logo />

        <nav className="hidden items-center gap-10 lg:flex">
          {NAV.map((item) => (
            <Link
              key={item.to}
              to={item.to}
              className="text-[11px] font-medium tracking-[0.2em] uppercase text-navy-900/80 transition-colors hover:text-gold-500"
              activeProps={{ className: "text-gold-500" }}
              activeOptions={{ exact: true }}
            >
              {item.label}
            </Link>
          ))}
        </nav>

        <div className="flex items-center gap-4">
          <Link
            to="/contacto"
            className="hidden border border-gold-500 px-6 py-3 text-[11px] font-semibold tracking-[0.2em] uppercase text-navy-900 transition-all hover:bg-gold-500 hover:text-white md:inline-block"
          >
            Consulta Privada
          </Link>
          <button
            type="button"
            aria-label="Abrir menú"
            onClick={() => setOpen((v) => !v)}
            className="lg:hidden text-navy-900"
          >
            {open ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
          </button>
        </div>
      </div>

      {open && (
        <div className="border-t border-gold-500/20 bg-stone-100 lg:hidden">
          <nav className="container-elegant flex flex-col py-4">
            {NAV.map((item) => (
              <Link
                key={item.to}
                to={item.to}
                onClick={() => setOpen(false)}
                className="border-b border-navy-900/5 py-4 text-sm font-medium tracking-widest uppercase text-navy-900 hover:text-gold-500"
                activeProps={{ className: "text-gold-500" }}
                activeOptions={{ exact: true }}
              >
                {item.label}
              </Link>
            ))}
          </nav>
        </div>
      )}
    </header>
  );
}